<template>
  <div class="global-message-with-dismiss-action-button">
    <p
      v-safe-html="sanitized_message"
      class="global-message-with-dismiss-action-button-text"
    />

    <div class="global-message-with-dismiss-action-button-buttons">
      <el-button
        type="text"
        plain
        @click.stop="handleDismiss"
      >
        {{ dismissButtonText }}
      </el-button>

      <el-button
        type="text"
        plain
        class="blue"
        @click="handleClick"
      >
        {{ actionButtonText }}
        <svg-icon icon-class="common-arrow-line-right" />
      </el-button>
    </div>
  </div>
</template>

<script>
import DomPurify from "dompurify";
export default {
  props: {
    message: { type: String, default: undefined },
    actionButtonText: { type: String, default: undefined },
    dismissButtonText: { type: String, default: undefined },
    onActionButtonClick: { type: Function, default: undefined },
    toastId: { type: [String, Number], default: undefined },
  },
  computed: {
    sanitized_message() {
      return DomPurify.sanitize(this.message);
    },
  },
  methods: {
    handleDismiss() {
      this.toastId && this.$toast.dismiss(this.toastId);
    },
    handleClick() {
      if (this.onActionButtonClick) {
        this.onActionButtonClick();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.global-message-with-dismiss-action-button {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &-text {
    color: var(--Black, #1d1d1d);

    /* 400/Regular 12 */
    font-family: Lato;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 150% */
    letter-spacing: 0.24px;
  }

  &-buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;

    button {
      @include button-size(12px, 0px, max-content, 18px, 100%, false);
    }
  }
}
</style>
